import AdminLinearSettings from './AdminLinearSettings';

export default AdminLinearSettings;
